import React from 'react';
import CoursesCoverImage from '../../components/courses-cover-image';
import GiftCardOverlayHeader from './gift-card-overlay-header';
import GiftCardInstructions from './gift-card-instructions';
import GiftCardQuote from './gift-card-quote';
import GiftCardStarRating from './gift-card-star-rating';
import GiftCardHeedImageBanner from './gift-card-heed-image-banner';
import GiftCardCoursesCarousel from './gift-card-courses-carousel';
import GiftCardEmployeesImageBanner from './gift-card-employees-image-banner';
import './styles.scss';

const GiftCardOverview = () => {
  return (
    <div className="courses-gift-card-overview">
      <CoursesCoverImage />

      <GiftCardOverlayHeader />

      <GiftCardInstructions />

      <GiftCardQuote />

      <GiftCardStarRating />

      <GiftCardHeedImageBanner />

      <GiftCardCoursesCarousel />

      <GiftCardEmployeesImageBanner />
    </div>
  );
};

export default GiftCardOverview;
